import * as React from 'react'

const SvgVideoCourseIcon = ({
  stroke,
  width = '22',
  height = '21',
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.57181 19.6C7.90661 18.9598 9.40997 18.6 11 18.6C12.59 18.6 14.0934 18.9598 15.4282 19.6M5.8 15.6H16.2C17.8802 15.6 18.7202 15.6 19.362 15.273C19.9265 14.9854 20.3854 14.5264 20.673 13.9619C21 13.3202 21 12.4801 21 10.8V6.39998C21 4.71982 21 3.87974 20.673 3.238C20.3854 2.67352 19.9265 2.21458 19.362 1.92696C18.7202 1.59998 17.8802 1.59998 16.2 1.59998H5.8C4.11984 1.59998 3.27976 1.59998 2.63803 1.92696C2.07354 2.21458 1.6146 2.67352 1.32698 3.238C1 3.87974 1 4.71982 1 6.39998V10.8C1 12.4801 1 13.3202 1.32698 13.9619C1.6146 14.5264 2.07354 14.9854 2.63803 15.273C3.27976 15.6 4.11984 15.6 5.8 15.6Z"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgVideoCourseIcon
